'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSagaTarget = exports.setupSagaTarget = undefined;

var _sagaTarget = require('./sagaTarget');

exports.setupSagaTarget = _sagaTarget.setupSagaTarget;
exports.getSagaTarget = _sagaTarget.getSagaTarget;
exports.default = {
    setupSagaTarget: _sagaTarget.setupSagaTarget,
    getSagaTarget: _sagaTarget.getSagaTarget
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/saga-utils/dist/main/index.js
// module id = 113
// module chunks = 0